module.exports = {
	"id": "FM",
	"name": "Micronesia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.025317,
			"26": 0.447267,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.008439,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.033756,
			"39": 0.033756,
			"40": 0.050634,
			"41": null,
			"42": null,
			"43": 0.016878,
			"44": null,
			"45": 0.025317,
			"46": null,
			"47": 0.025317,
			"48": 0.016878,
			"49": 0.767949,
			"50": 0.143463,
			"51": 0.565413,
			"52": 0.177219,
			"53": 41.849001,
			"54": 21.215646,
			"55": 0.042195,
			"56": 0.033756,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": 0.016878,
			"14": null,
			"15": null,
			"16": 0.008439,
			"17": null,
			"18": 0.016878,
			"19": 0.008439,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.016878,
			"25": 0.008439,
			"26": 0.016878,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.016878,
			"33": null,
			"34": 0.008439,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.008439,
			"39": 0.059073,
			"40": null,
			"41": null,
			"42": null,
			"43": 0.075951,
			"44": 0.042195,
			"45": 0.050634,
			"46": 0.033756,
			"47": 0.489462,
			"48": 0.464145,
			"49": 4.2195,
			"50": 0.270048,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.016878
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.016878,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.126585,
			"38": 0.008439,
			"39": null,
			"40": 0.075951,
			"41": 0.008439,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.033756,
			"6": null,
			"7": null,
			"8": 0.135024,
			"9": 0.109707,
			"10": 0.540096,
			"3.1": null,
			"3.2": null,
			"5.1": 0.067512,
			"6.1": 0.067512,
			"7.1": null,
			"9.1": 0.616047
		},
		"ios_saf": {
			"8": 0,
			"10": 1.88022125062,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0506697870525,
			"8.1-8.4": 0.0936102845545,
			"9.0-9.2": 0.0446581174022,
			"9.3": 0.681322560366
		},
		"android": {
			"3": 0,
			"4": 0.0375809741602,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00469762177003,
			"4.1": 0.135559942506,
			"4.2-4.3": 0.338899856266,
			"4.4": 0.777120858527,
			"4.4.3-4.4.4": 0.78383174677
		},
		"ie": {
			"6": 0.008439,
			"7": null,
			"8": 0.08439,
			"9": 0.227853,
			"10": 0.565413,
			"11": 6.135153,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0544712487403,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00151309024279
		},
		"edge": {
			"12": 0.565413,
			"13": 0.632925,
			"14": 0.388194
		},
		"ie_mob": {
			"10": 0.0298568732394,
			"11": 0.121560126761
		},
		"bb": {
			"7": 0.00741475,
			"10": null
		},
		"samsung": {
			"0": 0.502642
		},
		"and_uc": {
			"0": 1.865395
		},
		"op_mini": {
			"0": 0.733881661017
		},
		"and_chr": {
			"0": 9.503962
		},
		"and_ff": {
			"0": 0.020293
		}
	},
	"total": 99.40931675
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/FM.json
 ** module id = 521
 ** module chunks = 0
 **/